<script>
import { Doughnut, mixins } from 'vue-chartjs'

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  props: {
    options: {
      type: Object,
      default() {
          return {
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                  display: false
              },
              tooltips: {
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                borderColor: '#628aba',
                borderWidth: 1,
                xPadding: 15,
                yPadding: 12,
                titleFontColor: "#333",
                titleSpacing: 4,
                bodyFontColor: "#333",
                displayColors: false,
            },
           }
       },
    }
  },
  mounted () {
      
      console.log(this.options);
    this.renderChart(this.chartData, this.options)
  },
}
</script>
